import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 16l2 -6l6 -2l-2 6l-6 2","key":"svg-0"}],["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-1"}]]

const IconBrandSafari = createReactComponent('outline', 'brand-safari', 'BrandSafari', __iconNode);

export default IconBrandSafari;